import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";

const defaultStyles = {
  outlineOffset: -1,
  padding: "30px 25px",
  gap: "5px",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "15px",
  boxSizing: "border-box",
};

export const StyledDragnDrop = styled(Stack, {
  shouldForwardProp: (prop) => prop !== "customStyle",
})(({ hovering = false, theme }) => ({
  ...(hovering
    ? {
        ...defaultStyles,
        outline: `1px solid ${theme.palette.hubColors.mainFocus}`,
        backgroundColor: theme.palette.hubColors.mainFocusLightest,
      }
    : {
        ...defaultStyles,
        outline: `1px dashed ${theme.palette.hubColors.mainFocus}`,
        ":hover": {
          cursor: "pointer",
          outline: `1.5px dashed ${theme.palette.hubColors.mainFocus}`,
          outlineOffset: -1.5,
        },
      }),
}));

export const StyledProgressStack = styled(Stack)(({ theme }) => ({
  padding: "20px",
  width: "100%",
  gap: "8px",
  borderRadius: "5px",
  backgroundColor: theme.palette.hubColors.greyLighter,
  "& .MuiStack-root": {
    flexDirection: "row",
    gap: "10px",
    adjustContent: "center",
  },
}));
